import { create } from 'zustand';

import { invalidateNotificationQueries } from './helpers/invalidate-notification-queries';
import type { NotificationStore } from './types';

export const notificationStore = create<NotificationStore>()((set) => ({
  newPushNotification: null,
  setNewPushNotification: ({ newPushNotification, isForeground }) =>
    set((state) => {
      if (newPushNotification) {
        invalidateNotificationQueries(newPushNotification);
      }

      if (isForeground) {
        return {
          ...state,
          newPushNotification,
        };
      }

      return state;
    }),
}));
